import React, { useEffect, useState } from "react";
import { TrendingUp, TrendingDown, Activity, Target, BarChart2 } from "lucide-react";
import api from "../lib/api";
import { computeProximity } from "../lib/proximity";

export default function PortfolioStatsBar({ setups }) {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    api.portfolioSummary().then(setSummary).catch(() => {});
  }, [setups]);

  const inZoneCount = setups.filter(s => {
    const p = computeProximity(s);
    return p !== null && p <= 1.5;
  }).length;

  const activeCount = setups.filter(s => s.status !== "closed").length;

  const winRate = summary?.closed?.count > 0
    ? Math.round((summary.closed.winners / summary.closed.count) * 100)
    : null;

  const avgPnl = summary?.active?.avg_pnl_percent;

  const stats = [
    {
      label: "Aktive Setups",
      value: activeCount,
      icon: Activity,
      color: "text-zinc-100",
      sub: null,
    },
    {
      label: "In / Nahe Zone",
      value: inZoneCount,
      icon: Target,
      color: inZoneCount > 0 ? "text-emerald-400" : "text-zinc-500",
      highlight: inZoneCount > 0,
      sub: null,
    },
    {
      label: "Ø P&L (Offen)",
      value: avgPnl != null ? `${avgPnl > 0 ? "+" : ""}${avgPnl.toFixed(1)}%` : "—",
      icon: avgPnl != null && avgPnl >= 0 ? TrendingUp : TrendingDown,
      color: avgPnl == null ? "text-zinc-500" : avgPnl >= 0 ? "text-emerald-400" : "text-rose-400",
      sub: null,
    },
    {
      label: "Win-Rate",
      value: winRate != null ? `${winRate}%` : "—",
      icon: BarChart2,
      color: winRate == null ? "text-zinc-500" : winRate >= 50 ? "text-emerald-400" : "text-rose-400",
      sub: summary?.closed?.count ? `${summary.closed.winners}W / ${summary.closed.losers}L` : null,
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-px border-b border-zinc-700 bg-zinc-700 shrink-0">
      {stats.map((s) => {
        const Icon = s.icon;
        return (
          <div
            key={s.label}
            className={`bg-zinc-950 px-3 sm:px-5 md:px-8 py-4 flex items-center gap-3 ${s.highlight ? "bg-emerald-950/20" : ""}`}
          >
            <Icon size={18} className={`${s.color} shrink-0 opacity-60`} strokeWidth={1.5} />
            <div className="min-w-0">
              <div className={`font-display font-black text-2xl sm:text-3xl leading-none tracking-tight ${s.color}`}>
                {s.value}
              </div>
              <div className="text-[11px] text-zinc-500 uppercase tracking-[0.18em] font-display font-bold mt-1.5">
                {s.label}
              </div>
              {s.sub && <div className="text-xs text-zinc-600 font-mono-num mt-0.5">{s.sub}</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
